<canvas #signatureCanvas class="signature-handler" width="620" height="280">
  Your browser does not support the canvas element.
</canvas>
